import { render, staticRenderFns } from "./LineLangAnalysis.vue?vue&type=template&id=1765fb35&scoped=true"
import script from "./LineLangAnalysis.vue?vue&type=script&lang=js"
export * from "./LineLangAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1765fb35",
  null
  
)

export default component.exports